
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Shield } from "lucide-react";

export const AdminHeader = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2">
        <Shield className="h-6 w-6" />
        <h1 className="text-3xl font-bold">Admin Dashboard</h1>
      </div>
      
      <div className="flex space-x-2 border-b pb-2 overflow-x-auto">
        <Link
          to="/admin"
          className={`px-3 py-2 rounded-md ${
            currentPath === "/admin" ? "bg-primary text-primary-foreground" : "hover:bg-muted"
          }`}
        >
          Legacy
        </Link>
        <Link
          to="/admin/enhanced"
          className={`px-3 py-2 rounded-md ${
            currentPath === "/admin/enhanced" ? "bg-primary text-primary-foreground" : "hover:bg-muted"
          }`}
        >
          Enhanced
        </Link>
        <Link
          to="/admin/roles"
          className={`px-3 py-2 rounded-md ${
            currentPath === "/admin/roles" ? "bg-primary text-primary-foreground" : "hover:bg-muted"
          }`}
        >
          Roles
        </Link>
        <Link
          to="/admin/shortcuts"
          className={`px-3 py-2 rounded-md ${
            currentPath === "/admin/shortcuts" ? "bg-primary text-primary-foreground" : "hover:bg-muted"
          }`}
        >
          Shortcuts
        </Link>
        <Link
          to="/admin/shortcuts-manager"
          className={`px-3 py-2 rounded-md ${
            currentPath === "/admin/shortcuts-manager" ? "bg-primary text-primary-foreground" : "hover:bg-muted"
          }`}
        >
          Commands
        </Link>
      </div>
    </div>
  );
};
